import { BrowserRouter } from 'react-router-dom';
import QueryProvider from './providers/QueryProvider';
import WebSocketProvider from './providers/WebSocketProvider';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ToastContainer';
import ErrorBoundary from './components/ErrorBoundary';
import AppRouter from './routes';

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <QueryProvider>
          <AuthProvider>
            <ToastProvider>
              <WebSocketProvider>
                <AppRouter />
              </WebSocketProvider>
            </ToastProvider>
          </AuthProvider>
        </QueryProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
